<!-- 主页面 -->
<template>
  <div class="page index-page f-2" ref="page" @scroll="handlePageScroll">
    <div
      class="multi-bubble bubble-confirm as-flex flex-vertical main-center cross-center f-2"
      @click="changeMultiStatus(true)"
    >
      <span>{{currrentChosenMovies.length === 0?'多选':`${currrentChosenMovies.length }部`}}</span>
      <span>对比</span>
    </div>
    <div
      v-if="isMulti"
      class="multi-bubble bubble-cancel as-flex flex-vertical main-center cross-center f-2"
      @click="changeMultiStatus(false)"
    >
      <span>取消</span>
      <span>对比</span>
    </div>
    <div class="search-bar as-flex main-end cross-center">
      <div class="search-container">
        <el-input placeholder="搜索影片名" prefix-icon="el-icon-search" v-model="searchInfo"></el-input>
      </div>
    </div>
    <div :class="['filter-box','is-fixed']" ref="filterBox">
      <filterBox
        :filterTypesModel="filterTypes"
        :currentFilterFlag="currentFilter"
        @executeFilter="recieveFilterChange"
      ></filterBox>
    </div>
    <div
      :class="['sub-filter', 'as-flex','main-start', 'cross-center','f-2', true?'is-fixed':'']"
      :style="{top:true? subFilterBoxFixedEdge + 'px':0 +'px'}"
      ref="subFilterBox"
    >
      <div
        :class="['ordered-item', 'time-ordered', currentFilter.orderby === ''?'is-selected':'']"
        @click="validateChangeFilter('orderby','')"
      >时间排序</div>
      <div
        :class="['ordered-item', 'box-ordered', currentFilter.orderby === 'box'?'is-selected':'']"
        @click="validateChangeFilter('orderby','box')"
      >票房排序</div>
      <el-dropdown
        trigger="click"
        :class="['ordered-item',currentFilter.orderby && currentFilter.orderby !=='box'?'is-selected':'']"
      >
        <span class="el-dropdown-link">
          {{currentFilter.orderby && currentFilter.orderby !=='box'?orderbyMapping.find((item)=>{
          return item.id === currentFilter.orderby
          }).value:'指标排序' }}
          <i
            class="el-icon-arrow-down el-icon--right"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <template v-for="item in orderbyMapping">
            <el-dropdown-item :key="item.id" :disabled="disabledOrders.includes(item.id)">
              <div @click="validateChangeFilter('orderby',item.id)">{{item.value}}</div>
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <div class="cycle-filter"></div> -->
      <el-dropdown trigger="click" :class="['ordered-item','cycle-filter']">
        <span class="el-dropdown-link">
          {{currentFilter.cycle?cycleMapping.find((item)=>{
          return item.id === currentFilter.cycle
          }).value:'周期数据(最新)' }}
          <i
            class="el-icon-arrow-down el-icon--right"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div @click="validateChangeFilter('cycle','')">周期数据(最新)</div>
          </el-dropdown-item>
          <template v-for="item in cycleMapping">
            <el-dropdown-item :key="item.id" :disabled="disabledCycles.includes(item.id)">
              <div @click="validateChangeFilter('cycle',item.id)">{{item.value}}</div>
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="search-list" v-loading.fullscreen.lock="isLoadingMovie">
      <template v-for="item in movieList">
        <div
          :key="'movie_'+ item.movie.id"
          @click="isMulti?toggleCurrentChosenMovies(item.movie.id):setMainMovie(item.movie.id)"
          class="movie-box-container"
        >
          <movieBox
            :type="isMulti?'multi':'single'"
            :chosen="currrentChosenMovies.indexOf(item.movie.id)>=0"
            :movieInfo="item"
          ></movieBox>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import tagApi from "../api/tagApi.js";
import surveyApi from "../api/surveyApi.js";
import movie_resultsApi from "../api/movie_resultsApi.js";
import { clone, trim, debounce } from "lodash";
import filterBox from "../components/common/filterBox.vue";
import movieBox from "../components/common/movieBox.vue";
import { mapGetters } from "vuex";
// 设备识别

const orderbyMapping = [
  // { id: "box", value: "票房" },
  { id: "awareness", value: "认知" },
  { id: "interest", value: "兴趣" },
  { id: "primary", value: "首选" },
  { id: "rating", value: "喜爱" },
  { id: "recommendation", value: "推荐" },
  { id: "expectation", value: "预期达成" }
];
const cycleMapping = [
  { id: "-4", value: "映前4周" },
  { id: "-3", value: "映前3周" },
  { id: "-2", value: "映前2周" },
  { id: "-1", value: "映前1周" },
  { id: "0", value: "上映当周" },
  { id: "1", value: "映后1周" }
  // {id:"2",value:"映后两周"}
];
const weekthMapping = {
  "0": "本周",
  "-1": "下周"
};
export default {
  components: {
    filterBox: filterBox,
    movieBox: movieBox
  },
  data() {
    return {
      init: false,
      weekthMapping: weekthMapping,
      orderbyMapping: orderbyMapping,
      disabledOrders: [],
      disabledCycles: [],
      cycleMapping: cycleMapping,
      //page status
      isLoadingMovie: false,
      tagApi: new tagApi(),
      surveyApi: new surveyApi(),
      movie_resultsApi: new movie_resultsApi(),

      subFilterBoxFixedEdge: undefined,
      filterBoxIsFixed: false,
      subFilterBoxIsFixed: false,

      searchInfo: undefined,

      currrentChosenMovies: [],
      //page info
      pageinfo: {
        page: 1,
        per_page: 10
      },
      //init filter config
      filterTypes: { tags: true, location: true, box: true, year: true },
      //init filter  in  the filter-box
      currentFilter: {
        title: "",
        tags: "",
        location: "",
        box: "",
        year: "",
        orderby: "",
        cycle: ""
      },
      filterAbbreviation: "",

      movieList: [],
      noMovieListResult: false
    };
  },
  computed: {
    ...mapGetters({
      isMulti: "globalStatus/getSelectStatus"
    }),
    tabpageStatus: function() {
      return {
        currentFilter: clone(this.currentFilter),
        searchInfo: clone(this.searchInfo),
        disabledOrders: clone(this.disabledOrders),
        disabledCycles: clone(this.disabledCycles)
      };
    }
  },
  props: {},
  mixins: [],
  methods: {
    changeMultiStatus(data) {
      //if data is already true ,then goto multiCompaire
      if (data === true && this.currrentChosenMovies.length > 0) {
        this.multiCompaire();
        return;
      }
      this.$store.commit("globalStatus/setSelectStatus", { status: data });
      if (data === false) {
        this.currrentChosenMovies = [];
      }
    },
    toggleCurrentChosenMovies(id) {
      if (this.currrentChosenMovies.includes(id)) {
        this.currrentChosenMovies = this.currrentChosenMovies.filter(item => {
          return item !== id;
        });
      } else {
        //电影列表和详情列表 最多保持十个
        if (this.currrentChosenMovies.length === 10) {
          //一次性提示
          if (
            this.$store.getters["onceMessage/getAddCompaireMovieMoreThanTen"]
          ) {
            this.$message({
              showClose: true,
              message: "最多选择10部影片",
              type: "warning"
            });
          }
          return;
        }
        this.currrentChosenMovies.push(id);
      }
    },
    goCompaireDetailPagePreFix() {
      //如果所有所选择的影片均没有映前或者映后数据时，映前/映后数据页显示 暂无数据图片
    },
    setMainMovie(id) {
      this.$store.commit("movie/setMainMovie", { id: id });
      this.$store.commit("movie/updateTotalMovieState");
      this.$router.push({
        path: "movies",
        query: { compaire_type: "single" }
      });
    },
    multiCompaire() {
      this.$store.commit("movie/setCycleMoviesList", {
        list: this.currrentChosenMovies
      });
      this.$store.commit("movie/updateTotalMovieState");
      this.$router.push({
        path: "movies",
        query: { compaire_type: "multi" }
      });
    },
    showFixedFullFilter() {
      this.fixedFilter.isShrink = false;
    },
    recieveFilterChange(info) {
      if (
        // info.orderby === this.currentFilter.orderby &&
        info.box === this.currentFilter.box &&
        info.year === this.currentFilter.year &&
        info.location === this.currentFilter.location &&
        // info.cycle === this.currentFilter.cycle &&
        info.tags === this.currentFilter.tags &&
        info.range_year === this.currentFilter.range_year &&
        info.range_box === this.currentFilter.range_box
      ) {
        return;
      }
      this.currentFilter = Object.assign(info, {
        title: this.searchInfo
      });
      //handle with this.currentFilter
      //call api to filter info
    },
    changeCurrentFilter(key, value) {
      this.currentFilter[key] = value;
    },
    //函数validateFilter,验证成功返回true，否则返回false
    validateChangeFilter(key, value) {
      let to = Object.assign({}, this.currentFilter, { [key]: value });
      let from = Object.assign({}, this.currentFilter);
      this.changeCurrentFilter(key, value);
      //添加筛选标签之间的联系
      //当排序不是 认知度1/兴趣度2/首选度3 喜爱度4/推荐度5/预期达成6 时，disabled标签清空
      if (
        ![
          "awareness",
          "interest",
          "primary",
          "rating",
          "recommendation",
          "expectation"
        ].includes(to.orderby)
      ) {
        this.disabledOrders = [];
        this.disabledCycles = [];
      }
      //认知度1/兴趣度2/首选度3:默认自动将周期切换变成“上映当周”
      if (
        ["awareness", "interest", "primary"].includes(to.orderby) &&
        to.orderby !== from.orderby &&
        !["awareness", "interest", "primary"].includes(from.orderby)
      ) {
        // 选中映前数据标签，映后一周选项默认disabled
        this.disabledCycles = [];
        if (!this.disabledCycles.includes("1")) {
          this.disabledCycles.push("1");
        }
        this.changeCurrentFilter("cycle", "0");
      }
      //喜爱度4/推荐度5/预期达成6:默认自动将周期切换变成“映后1周”
      if (
        ["rating", "recommendation", "expectation"].includes(to.orderby) &&
        to.orderby !== from.orderby &&
        !["rating", "recommendation", "expectation"].includes(from.orderby)
      ) {
        //选中映前数据标签，映前几周选项默认disabled
        this.disabledCycles = [];
        for (let i = -4; i < 1; i++) {
          if (!this.disabledCycles.includes(`${i}`)) {
            this.disabledCycles.push(`${i}`);
          }
        }
        this.changeCurrentFilter("cycle", "1");
      }
      //上映时间排序:默认自动将周期切换变成“默认”
      if ([""].includes(to.orderby) && to.orderby !== from.orderby) {
        this.changeCurrentFilter("cycle", "");
      }
      //周期默认时:默认自动将排序切换变成“上映时间”
      if ([""].includes(to.cycle) && to.cycle !== from.cycle) {
        this.changeCurrentFilter("orderby", "");
      }
    },
    async executeFilter(info, type = "refresh") {
      this.isLoadingMovie = true;
      //handle with this.currentFilter
      let params = {};
      params.title = trim(this.searchInfo);
      params.sort = info.orderby;
      params.offset = info.cycle;
      params.box = info.box;
      params.year = info.year;
      params.tag_ids = [info.tags, info.location].filter(item => {
        return item !== "";
      });
      params.range_year = info.range_year || [];
      params.range_box = info.range_box || [];
      if (type === "refresh") {
        params.page = 1;
        if (this.$refs.page && this.$refs.page.scrollTo) {
          this.$refs.page.scrollTo(0, 0);
        } else if (this.$refs.page && this.$refs.page.scrollTop) {
          this.$refs.page.scrollTop = 0;
        }
      } else {
        params.page = this.pageinfo.page + 1;
      }
      params.per_page = this.pageinfo.per_page;
      try {
        let res = await this.movie_resultsApi.searchMovieResult(params);
        if (res.status === true && res.code === 200) {
          this.noMovieListResult = res.data.length > 0 ? false : true;
          if (type === "refresh") {
            this.pageinfo.page = 1;
            this.movieList = res.data;
          } else {
            //type = loadmore
            if (this.noMovieListResult) {
              //没有更多
              this.$message({
                showClose: true,
                message: "已经到底啦",
                type: "warning"
              });
            }
            this.pageinfo.page += 1;
            this.movieList = this.movieList.concat(res.data);
          }
          this.isLoadingMovie = false;
        } else {
          this.isLoadingMovie = false;
        }
      } catch (e) {
        this.isLoadingMovie = false;
        // throw new Error("接口调用错误");
      }
      //call api to filter info
    },
    initPageInfo() {
      this.pageinfo.page = 1;
    },
    async refresh() {
      //call api to refresh data
      this.pageinfo.page = 1;
      await this.executeFilter(this.currentFilter);
    },
    async pullUploadMore() {
      //call api to load more data
      await this.executeFilter(this.currentFilter, "loadmore");
    },
    handlePageScroll() {
      let scrollTop = this.$refs.page.scrollTop;
      let filterBoxTopHeight = this.$refs.filterBox.offsetTop;
      let filterBoxHeight = this.$refs.filterBox.offsetHeight;
      //页面筛选条固定条件
      this.subFilterBoxFixedEdge = filterBoxHeight;
      let subFilterBoxTopHeight = this.$refs.subFilterBox.offsetTop;
      if (filterBoxTopHeight <= scrollTop) {
        this.filterBoxIsFixed = true;
      } else {
        this.filterBoxIsFixed = false;
      }
      if (subFilterBoxTopHeight <= scrollTop + filterBoxHeight) {
        this.subFilterBoxIsFixed = true;
      } else {
        this.subFilterBoxIsFixed = false;
      }
      //触底加载更多
      let offsetHeight = this.$refs.page.clientHeight;
      let scrollHeight = this.$refs.page.scrollHeight;
      let minus = offsetHeight + scrollTop;
      if (Math.abs(scrollHeight - minus) < 1) {
        this.pullUploadMore();
      }
    },
    tabPageSetting() {
      let statusCode = this.$route.query.statusCode;
      if (statusCode) {
        //有statusCode,均是点击页签进入，根据statusCode从store中拿取数据，并且不再需要pushTab
        this.$store.commit("tabpage/setCurrentTabByStatusCode", {
          statusCode: statusCode
        });
        let tabpageInfo = this.$store.getters[
          "tabpage/getCurrentTabStatusInfo"
        ];
        this.initPageTabInfo(tabpageInfo);
        return;
      }
      this.$store.commit("tabpage/pushTab", {
        title: "影片库",
        pathname: this.$route.name || "notfound",
        pathquery: Object.assign({}, this.$route.query),
        // pathparams: Object.assign({}, this.$route.params),
        type: "movieLib",
        statusInfo: {
          mainMovie: undefined,
          movieList: undefined,
          filters: {}
        }
      });
    },
    initPageTabInfo(data) {
      if (!data.filters) {
        return;
      }
      //将filter中的数据映射回来
      Object.entries(data.filters).forEach(item => {
        if (item[0] !== undefined) {
          this[item[0]] = clone(item[1]);
        }
      });
    }
  },
  async created() {
    if (this.$route.query.searchInfo) {
      this.searchInfo = decodeURIComponent(this.$route.query.searchInfo);
      this.tabPageSetting();
    } else {
      this.tabPageSetting();
      //init page config
      this.initPageInfo();
    }
    this.$store.commit("movie/setMainMovie", {
      id: undefined
    });
    if (this.$store.getters["user/isLogined"]) {
      await this.executeFilter(this.currentFilter);
    }
    this.init = true;
  },
  watch: {
    tabpageStatus: {
      handler: function(to, from) {
        if (!this.init) {
          return;
        }
        this.$store.commit("tabpage/updateCurrentTab", {
          statusInfo: {
            filters: clone(to)
          }
        });
      },
      deep: true
    },
    searchInfo: function(to, from) {
      this.currentFilter = Object.assign(this.currentFilter, {
        title: to
      });
    },
    currentFilter: {
      //listen this.currentFilter and excute query when change
      handler: async function(to, from) {
        this.initPageInfo();
        await this.executeFilter(to);
      },
      deep: true
    },
    isLoadingMovie: function(to, from) {
      // if (to) {
      //   Indicator.open({
      //     text: "数据加载中",
      //     spinnerType: "fading-circle"
      //   });
      // } else {
      //   Indicator.close();
      // }
    },
    $route: function(to, from) {
      if (to.query.searchInfo) {
        let search = decodeURIComponent(to.query.searchInfo);
        this.searchInfo = search;
      }
    }
  },
  destroyed() {
    // Indicator.close();
    this.$store.commit("globalStatus/setSelectStatus", {
      status: false
    });
  }
};
</script>

<style lang="scss" scoped>
.index-page {
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  // height: 100%;
  position: relative;
  overflow-y: scroll;
  padding: 0 20px;
  margin: 0;
  min-width: 800px;
}
.search-bar {
  height: 50px;
  width: 100%;
  padding: 5px 0;
  .search-container {
    width: 200px;
    height: 100%;
  }
}
.filter-box {
  width: 100%;
  // max-height: 400px;
  background-color: #fff;
  margin-bottom: 20px;
  &.is-fixed {
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    z-index: 999;
  }
}
.sub-filter {
  height: 50px;
  width: 100%;
  padding: 0 10px;
  background-color: #fff;
  position: sticky;
  position: -webkit-sticky;
  box-shadow: 0px 2px 2px -2px #efefef;
  z-index: 999;
  // &.is-fixed {
  //   position: sticky;
  //   position: -webkit-sticky;
  //   box-shadow: 0px 2px 2px -2px #efefef;
  //   z-index: 9999;
  // }
  .ordered-item {
    cursor: pointer;
    margin: 0 10px;
    border-bottom: 2px solid rgba(0, 0, 0, 0);
    &:hover {
      color: #61b6e6;
    }
    &.is-selected {
      color: #008cd6;
      border-bottom: 2px solid #008cd6;
    }
  }
  .cycle-filter {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.search-list {
  flex-grow: 1;
  // overflow-y: scroll;
  .movie-box-container {
    height: 150px;
    width: 100%;
    border-bottom: 1px solid #efefef;
  }
}

.multi-bubble {
  position: fixed;
  height: 50px;
  width: 50px;
  border-radius: 25px;
  z-index: 999;
  background-color: #008cd6;
  box-shadow: 0px 0px 2px 2px #61b6e6;
  color: #fff;
  cursor: pointer;
  &:hover {
    animation: pulse 1.5s infinite;
  }
  &.bubble-confirm {
    bottom: 100px;
    right: 100px;
  }
  &.bubble-cancel {
    bottom: 20px;
    right: 100px;
    background-color: #aaaaaa;
    box-shadow: 0px 0px 2px 2px #aaaaaa;
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

//overwrite element-style
/deep/ .el-input__inner {
  height: 2.5em;
  font-size: 15px;
  border-radius: 1.25em;
  border: none;
  background-color: #f1f1f1;
}
</style>

